<ng-content select="[mat-card-avatar], [matCardAvatar]"></ng-content><div class="mat-card-header-text"><ng-content select="mat-card-title, mat-card-subtitle,
      [mat-card-title], [mat-card-subtitle],
      [matCardTitle], [matCardSubtitle]"></ng-content></div><ng-content></ng-content>


// WEBPACK FOOTER //
// /home/travis/build/Pedro-vk/Bet-Token-wallet/node_modules/@angular/material/card/typings/index.d.ts.MatCardHeader.html